import { useEffect, useState } from "react";
import { api, formatApiError } from "../api/client";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

const REVIEW_ROLES = ["owner", "admin", "compliance_manager"];

export default function SubmitForReviewModal({ open, onClose, doc, onDone }) {
  const [users, setUsers] = useState([]);
  const [reviewer, setReviewer] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/users?page=1&page_size=100");
      setUsers((data.items || []).filter((u) => REVIEW_ROLES.includes(u.role)));
    })();
  }, []);

  const candidates = users.filter((u) => u.id !== doc.created_by_user_id);
  const onlyMyself = users.length > 0 && candidates.length === 0;

  const submit = async () => {
    if (!reviewer) return toast.error("Selecciona un revisor.");
    setBusy(true);
    try {
      const selfReview = reviewer === doc.created_by_user_id;
      const { data } = await api.post(`/documents/${doc.id}/submit-for-review`, {
        reviewer_user_id: reviewer, note, self_review: selfReview,
      });
      toast.success("Enviado a revisión.");
      onDone(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="modal-submit-review">
        <DialogHeader><DialogTitle>Enviar a revisión</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Revisor</Label>
            <Select value={reviewer} onValueChange={setReviewer}>
              <SelectTrigger data-testid="review-select"><SelectValue placeholder="Selecciona..." /></SelectTrigger>
              <SelectContent>
                {candidates.map((u) => <SelectItem key={u.id} value={u.id}>{u.name} · {u.role}</SelectItem>)}
                {onlyMyself && users[0] && <SelectItem value={users[0].id}>{users[0].name} (tú mismo)</SelectItem>}
              </SelectContent>
            </Select>
            {onlyMyself && (
              <p className="text-[12px] text-amber-700 mt-2">
                Eres el único revisor disponible. Si continúas aprobarás tu propio documento, lo cual debilita la separación de funciones. Considera invitar a otro Compliance Manager o Admin.
              </p>
            )}
          </div>
          <div>
            <Label>Nota para el revisor (opcional)</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} data-testid="review-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancelar</Button>
          <Button onClick={submit} disabled={busy} data-testid="review-submit">{busy ? "Enviando..." : "Enviar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
